<template>
    <div class="image_preview" v-show="isShowImagePreview">
       <div class="_2ibkP3"></div>
       <div class="_2jDHp5" @click.stop="imageClick">
        <img :src="previewList[imgInd]" alt="" class="L-NY99 _3G_AE-" >
        <div class="_2TG34g" @click.stop="toPrev" role="button" tabindex="-1" aria-label="上一张"><i aria-label="icon: left" class="el-icon-arrow-left"></i></div>
        <div class="_2kc3FH" @click.stop="toNext" role="button" tabindex="-1" aria-label="下一张"><i aria-label="icon: right" class="el-icon-arrow-right"></i></div>

       </div>
    </div>
</template>
<script>
export default {
    props:["previewList","showImgInd"],
    data () {
        return {
            imgInd:0,
            isShowImagePreview:false,


        }
    },
    methods: {
        showPreview (isShowImagePreview) {
            this.imgInd = this.showImgInd;
            const _2TG34g1 = document.getElementsByClassName('_2TG34g')[0]
            const _2kc3FH1 = document.getElementsByClassName('_2kc3FH')[0]
            _2kc3FH1.classList.remove('_3yUKnr')
            _2TG34g1.classList.remove('_3yUKnr')
            if (this.imgInd == 0) {
                _2TG34g1.classList.add('_3yUKnr')
            }
            if (this.imgInd == this.previewList.length-1) {
                _2kc3FH1.classList.add('_3yUKnr')
            }
            this.isShowImagePreview = isShowImagePreview;
        },
        imageClick () {
            const community = document.getElementsByClassName('community')[0]
            community.style.overflow = "unset";
            community.style.height = "unset";
            this.isShowImagePreview = false
        },
        toPrev () {
            const _2TG34g = document.getElementsByClassName('_2TG34g')[0]
            const _2kc3FH = document.getElementsByClassName('_2kc3FH')[0]
            if (this.imgInd < this.previewList.length-1) {
                _2kc3FH.classList.remove('_3yUKnr')
            }
            if (this.imgInd <= 0) {
                _2TG34g.classList.add('_3yUKnr')
                _2kc3FH.classList.remove('_3yUKnr')
                return false
            }
            _2TG34g.classList.remove('_3yUKnr')
            this.imgInd--
        },
        toNext () {
            const _2kc3FH = document.getElementsByClassName('_2kc3FH')[0]
            const _2TG34g = document.getElementsByClassName('_2TG34g')[0]
            if (this.imgInd > 0) {
                _2TG34g.classList.remove('_3yUKnr')
            }
            if (this.imgInd >= this.previewList.length-1) {
            _2kc3FH.classList.add('_3yUKnr')
            _2TG34g.classList.remove('_3yUKnr')
              return false  
            }
            _2kc3FH.classList.remove('_3yUKnr')
            this.imgInd++   
        }
    }
}
</script>
<style scoped>
*:focus {
  outline: none
}
._2ibkP3 {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    height: 100vh;
    overflow: hidden;
    z-index: 1100;
    background-color: rgba(0,0,0,.5);
}
._2jDHp5 {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1150;
    overflow: hidden;
    outline: 0;
    -webkit-overflow-scrolling: touch;
    display: flex;
    justify-content: center;
}
._3G_AE- {
    transition: none;
}
.L-NY99 {
    height: auto;
    max-height: 100vh;
    max-width: 100%;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: zoom-out;
    transition: transform .2s ease-in-out;
    transform-origin: 0 0;
    background-color: #fff;
    vertical-align: middle;
    border-style: none;
    /* transform: translate3d(573.924px, 0px, 0px)  */
    /* transform:translate(-50%,-50%); */
}
._2kc3FH, ._2TG34g {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 60px;
    height: 60px;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: #fff;
    background-color: rgba(64,64,64,.3);
    cursor: pointer;
    -moz-user-select: none; /*火狐*/
    -webkit-user-select: none; /*webkit浏览器*/
    -ms-user-select: none; /*IE10*/
    -khtml-user-select: none; /*早期浏览器*/
    user-select: none;

}
._3yUKnr {
    cursor: not-allowed;
    opacity: .5;
}
._2TG34g {
    left: 24px;
}
._2kc3FH {
    right: 24px;
}

</style>



// WEBPACK FOOTER //
// src/components/common/image_preview_dialog.vue